import React from 'react';
import { Button, Stack } from '@mui/material';
import { CheckCircleOutline, Cancel as CancelIcon } from '@mui/icons-material';

interface ApprovalActionBarProps {
  disabled?: boolean;
  onApprove: () => void;
  onReject: () => void;
}

const ApprovalActionBar: React.FC<ApprovalActionBarProps> = ({ disabled, onApprove, onReject }) => (
  <Stack direction="row" gap={2} justifyContent="flex-end">
    <Button
      variant="outlined"
      color="error"
      startIcon={<CancelIcon />}
      disabled={disabled}
      onClick={onReject}
    >
      Reject
    </Button>
    <Button
      variant="contained"
      startIcon={<CheckCircleOutline />}
      sx={{
        backgroundColor: '#162346',
        fontWeight: 600,
        '&:hover': { backgroundColor: '#1a2a52' },
      }}
      disabled={disabled}
      onClick={onApprove}
    >
      Approve
    </Button>
  </Stack>
);

export default ApprovalActionBar;
